export default "__VITE_ASSET__f776d39e__"